<script>
  import ToggleButton from "./ToggleButton.svelte";
  import FlexDetails from "./FlexDetails.svelte";

  export let value = $$props.value;
  const {config} = $$props;
</script>

<ToggleButton {...$$props} {config} bind:value />

{#if $$props.detailKey === $$props.key}
  <FlexDetails {...$$props} />
{/if}